import { categories } from '@/mocks/seoData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20ecommerce%20lifestyle%20scene%20featuring%20curated%20fashion%20products%20elegantly%20displayed%20on%20a%20light%20wooden%20surface%2C%20soft%20natural%20window%20light%2C%20cream%20beige%20neutral%20background%2C%20abstract%20organic%20shapes%20in%20gentle%20warm%20tones%2C%20editorial%20product%20photography%20style%20with%20subtle%20shadows%20and%20sophisticated%20composition%2C%20no%20text%20no%20people%2C%20harmonious%20aesthetic&width=1600&height=900&seq=hero-main-sugargoo-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="flex flex-wrap gap-2 justify-center mb-6">
          <span className="px-3 py-1 text-xs font-medium bg-white/20 backdrop-blur-sm text-white rounded-full border border-white/20 whitespace-nowrap">
            <i className="ri-check-line mr-1"></i>Updated Resources
          </span>
          <span className="px-3 py-1 text-xs font-medium bg-white/20 backdrop-blur-sm text-white rounded-full border border-white/20 whitespace-nowrap">
            <i className="ri-check-line mr-1"></i>Beginner Friendly
          </span>
          <span className="px-3 py-1 text-xs font-medium bg-white/20 backdrop-blur-sm text-white rounded-full border border-white/20 whitespace-nowrap">
            <i className="ri-check-line mr-1"></i>Product Research Hub
          </span>
          <span className="px-3 py-1 text-xs font-medium bg-white/20 backdrop-blur-sm text-white rounded-full border border-white/20 whitespace-nowrap">
            <i className="ri-check-line mr-1"></i>Shopping Knowledge Base
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
          The Ultimate <strong className="font-heading">Sugargoo Spreadsheet</strong> Resource
        </h1>

        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto mb-8 leading-relaxed">
          Discover thousands of organized <strong>Sugargoo Spreadsheet</strong> product finds, QC information,
          buying guides, shipping tips, and updated spreadsheets designed to help international shoppers
          make smarter purchasing decisions.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 text-sm font-semibold bg-accent-500 text-white rounded-md hover:bg-accent-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Explore Sugargoo Spreadsheet
            <i className="ri-arrow-right-line ml-2"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-6 py-3 text-sm font-semibold bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-md hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Visit Main Website
            <i className="ri-external-link-line ml-2"></i>
          </a>
        </div>

        <div className="mt-10">
          <p className="text-xs text-white/60 mb-3 uppercase tracking-widest">Browse by Category</p>
          <div className="flex flex-wrap gap-2 justify-center max-w-3xl mx-auto">
            {categories.map((cat) => (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-3 py-1.5 text-xs font-medium bg-white/10 backdrop-blur-sm text-white/90 border border-white/15 rounded-full hover:bg-white/20 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-2 bg-white/50 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}